/**
 * Next.js Client Instrumentation
 *
 * Loaded before React hydration (Next.js 15.3+). Schedules the fleet-wide
 * PostHog bootstrap in @infra/analytics - session replay, error tracking,
 * heatmaps, dead clicks, web vitals, and the `app` super property (multi-app
 * segmentation) all come from the shared config.
 *
 * @see https://posthog.com/docs/libraries/next-js#option-1-instrumentation-file
 */

import { initPostHogBrowserWhenIdle } from '@infra/analytics/posthog/deferred-instrumentation';

// posthog-js is the biggest script on this marketing site, so it loads once the
// page is loaded and idle (or on first interaction), not before first paint.
initPostHogBrowserWhenIdle({ appName: 'pulse-website' });
